import { DateTime } from 'luxon';
import { showUtcDate, showUtcWhen } from './utcDateTime';

/** Operator-visible instants. Date-only callers stay date-only; everything else is the UTC clock. */
export const formatDate = (dateString, format = DateTime.DATETIME_FULL) =>
  format === DateTime.DATE_SHORT ? showUtcDate(dateString) : showUtcWhen(dateString);

export const getStatusColor = status => {
  return status === 'ACTIVE' ? 'bg-success' : 'bg-danger';
};

export const getPromoTypeColor = promoType => {
  return promoType === 'FRAGMENT' ? 'bg-primary' : 'bg-warning';
};

export const customRound = amount => {
  // Check the fractional part of the product
  const fractionalPart = amount % 1;

  // Decide whether to add an epsilon to handle the 0.999 case
  const epsilon = fractionalPart >= 0.999 ? 0.0005 : 0;

  // Compute and return the rounded result
  const roundedProduct = Math.round((amount + epsilon) * 1000) / 1000;

  return roundedProduct;
};
